import { api } from "./client";

export interface AuthUser {
  id: string;
  email: string;
  role?: string;
}

export interface AuthResponse {
  user: AuthUser;
  access_token: string;
  refresh_token: string;
  access_token_expires_at: number;
  refresh_token_expires_at: number;
}

export function login(email: string, password: string): Promise<AuthResponse> {
  return api<AuthResponse>("/v1/auth/login", { method: "POST", body: { email, password }, auth: false });
}

export function signup(email: string, password: string, displayName?: string): Promise<AuthResponse> {
  return api<AuthResponse>("/v1/auth/signup", {
    method: "POST",
    body: { email, password, display_name: displayName },
    auth: false,
  });
}

export function logout(): Promise<{ logged_out: boolean }> {
  return api("/v1/auth/logout", { method: "POST" });
}

export function getMe(): Promise<AuthUser & { display_name?: string; created_at: number }> {
  return api("/v1/me");
}

export function getWsTicket(channels: string[]): Promise<{ ticket: string; expires_in: number }> {
  return api(`/v1/me/ws-ticket?channels=${encodeURIComponent(channels.join(","))}`);
}
